module.exports = __webpack_public_path__ + "img/uconnect.e6f8ff37.png";